import * as Joi from "joi";
import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { GenPartial } from 'typeormgen';
import { COLORS } from '../enums/enums';
import PictureRelation from '../picture-relations/picture-relation.entity';
import Picture from '../pictures/picture.entity';
import SetPiece from '../set-pieces/set-piece.entity';

@Entity('set_piece_pictures')
export default class SetPiecePicture extends PictureRelation {
	static tableName = 'set_piece_pictures';

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	set_piece_id: number;

	@Column('int')
	episodic_id: number;

	@ManyToOne((type) => SetPiece, (setPiece) => setPiece.setPiecePictures)
	@JoinColumn({
		name: 'set_piece_id',
	})
	setPiece: SetPiece;

	@ManyToOne((type) => Picture, (picture) => picture.setPiecePictures)
	@JoinColumn({ name: 'picture_id' })
	picture: Picture;

	static rules() {
		return {
			...PictureRelation.rules(),
			episodic_id: Joi.number().integer(),
			mobile_id: Joi.string().max(36).allow(null, ''),
			set_piece_id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			episodic_id: this.episodic_id,
			set_piece_id: this.set_piece_id,
		};
	}

	constructor(props?: GenPartial<SetPiecePicture>) {
		super(props);
	}

	getTagColor() {
		return COLORS.INVENTORY_LIGHT;
	}

	getTagRemoveColor() {
		return COLORS.INVENTORY;
	}
}
